// React
import { ReactNode, useEffect } from 'react';
import { ReactLenis, useLenis } from 'lenis/react';
import { useLocation } from '@tanstack/react-router';

// Types
type SmoothScrollProps = {
  children: ReactNode;
};

export const SmoothScroll = ({ children }: SmoothScrollProps) => {
  const lenis = useLenis();
  const location = useLocation();

  // Scroll to top on route change
  useEffect(() => {
    if (lenis) {
      lenis.scrollTo(0, { immediate: true });
    }
  }, [lenis, location.pathname]);

  return (
    <ReactLenis
      root
      options={{
        lerp: 0.1,
        duration: 1.2,
        smoothWheel: true,
        wheelMultiplier: 1,
        touchMultiplier: 2,
        infinite: false,
      }}
    >
      {children}
    </ReactLenis>
  );
};





